const AccessToken = localStorage.getItem('accessToken')

export const auth = {
  namespaced: true,
  state: {
    loggedIn: !!AccessToken,
    UserData: null
  },
  getters: {
    getSessionUser: state => {
      if (state.UserData) {
        return state.UserData
      }
      const userJson = localStorage.getItem('ai_platform_user')
      if (userJson) {
        try {
          return JSON.parse(userJson)
        } catch (e) {
          return null
        }
      }
      return null
    }
  },
  actions: {
    login ({ commit }, userObj) {
      commit('loginSuccess', userObj)
    },
    logout ({ commit }) {
      commit('logout')
    },
    refreshAccessToken ({ commit }, accessToken) {
      commit('refreshAccessToken', accessToken)
    }
  },
  mutations: {
    loginSuccess (state, userObj) {
      state.loggedIn = true
      state.UserData = userObj.userData
      localStorage.setItem('accessToken', userObj.accessToken)
    },
    setUserData (state, userData) {
      state.UserData = userData
      state.loggedIn = true
    },
    logout (state) {
      state.UserData = null
      state.loggedIn = false
      localStorage.removeItem('accessToken')
    },
    refreshAccessToken (state, accessToken) {
      localStorage.setItem('accessToken', accessToken)
      state.loggedIn = true
    }
  }
}
